import { useState, useEffect } from 'react'
import FormModal from './FormModal'

function AssignSecretModal({ isOpen, onClose, secret, onAssign }) {
  const [characters, setCharacters] = useState([])
  const [selectedCharacterId, setSelectedCharacterId] = useState('')
  const [notes, setNotes] = useState('')
  const [loading, setLoading] = useState(true)
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    if (isOpen) {
      // Fetch all player characters
      fetch('/api/characters')
        .then(res => res.json())
        .then(data => {
          // A non-OK response (e.g. a 401) still has a JSON body (`{error:
          // "..."}`), not an array — handing that straight to
          // setCharacters() would make characters.map() below throw during
          // render. See the identical guard in FeywildPage.jsx's
          // fetchPowers.
          setCharacters(Array.isArray(data) ? data : [])
          setLoading(false)
        })
        .catch(err => {
          console.error('Failed to fetch characters:', err)
          setLoading(false)
        })
    }
  }, [isOpen])

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!selectedCharacterId) return

    setIsSubmitting(true)

    try {
      await onAssign({
        secret_id: secret.id,
        character_id: parseInt(selectedCharacterId),
        notes: notes
      })
      setSelectedCharacterId('')
      setNotes('')
      onClose()
    } catch (error) {
      console.error('Assignment error:', error)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title={`Assign "${secret?.name}" to Player`}
      submitText="Assign Secret"
      isSubmitting={isSubmitting}
    >
      {loading ? (
        <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--text-muted)' }}>
          Loading characters...
        </div>
      ) : (
        <>
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{
              display: 'block',
              color: 'var(--text-primary)',
              marginBottom: '0.5rem',
              fontSize: '0.95rem',
              fontWeight: 500
            }}>
              Select Character *
            </label>
            <select
              value={selectedCharacterId}
              onChange={(e) => setSelectedCharacterId(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '0.75rem',
                background: 'var(--accent-deep)',
                border: '1px solid var(--accent-teal)',
                borderRadius: '6px',
                color: 'var(--text-primary)',
                fontSize: '0.95rem',
                fontFamily: 'inherit',
                cursor: 'pointer',
              }}
            >
              <option value="" style={{ background: 'var(--accent-deep)', color: 'var(--text-primary)' }}>
                -- Select a character --
              </option>
              {characters.map(char => (
                <option key={char.id} value={char.id} style={{ background: 'var(--accent-deep)', color: 'var(--text-primary)' }}>
                  {char.character_name} ({char.username})
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{
              display: 'block',
              color: 'var(--text-primary)',
              marginBottom: '0.5rem',
              fontSize: '0.95rem',
              fontWeight: 500
            }}>
              DM Notes (optional)
            </label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Notes about this secret for this character..."
              style={{
                width: '100%',
                padding: '0.75rem',
                background: 'var(--accent-deep)',
                border: '1px solid var(--accent-teal)',
                borderRadius: '6px',
                color: 'var(--text-primary)',
                fontSize: '0.95rem',
                fontFamily: 'inherit',
                minHeight: '100px',
                resize: 'vertical',
              }}
            />
          </div>

          <div style={{
            background: 'rgba(42, 85, 102, 0.2)',
            padding: '1rem',
            borderRadius: '8px',
            marginBottom: '1rem'
          }}>
            <div style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginBottom: '0.5rem' }}>
              <strong>Secret Preview:</strong>
            </div>
            <div style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>
              {secret?.description}
            </div>
          </div>
        </>
      )}
    </FormModal>
  )
}

export default AssignSecretModal
